export default __webpack_public_path__ + "static/media/keyvault.9987566e.svg";